import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { translateFn } from '../../../../../utils/translator.helper';
import { WEB_COMPONENT_GOLDEN_IMAGE_ASSIGNATION } from '../../../../../webcomponents.constants';
import { FontSizes } from '../../../../../types/common/types';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { htmlEncode } from '../../../../../utils/escape.utils';
import { styles } from './view/styles';

export enum GoldenImageAssignation {
  ASSIGN = 0,
  UNASSIGN = 1,
}

@customElement(WEB_COMPONENT_GOLDEN_IMAGE_ASSIGNATION)
export class GzGoldenImageAssignationWebComponent extends LitElement {
  @property({ attribute: true, reflect: true, type: GoldenImageAssignation })
  type: GoldenImageAssignation;

  @property({ attribute: true, reflect: true, type: String })
  endpointName: string;

  @property({ attribute: true, reflect: true, type: String })
  companyName: string;

  static get styles() {
    return styles;
  }

  protected render() {
    return html`
      ${this.type === GoldenImageAssignation.ASSIGN
        ? html`
            <gz-text fontSize="${FontSizes.HEADING_6}"
              >${Application.Main.company.isPartner()
                ? unsafeHTML(
                    translateFn(
                      'You are about to set <b>{endpointName}</b> as a Golden Image for company <b>{companyName}</b>.',
                      {
                        endpointName: htmlEncode(this.endpointName),
                        companyName: htmlEncode(this.companyName),
                      }
                    )
                  )
                : unsafeHTML(
                    translateFn('You are about to set <b>{endpointName}</b> as a Golden Image.', {
                      endpointName: htmlEncode(this.endpointName),
                    })
                  )}
            </gz-text>
          `
        : html`
            <gz-text fontSize="${FontSizes.HEADING_6}"
              >${translateFn('The selected endpoint will no longer be marked as a Golden Image.')}</gz-text
            >
          `}
    `;
  }
}
